import type { ReactNode } from 'react';
import { clsx } from 'clsx';

interface EmptyStateProps {
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  title: ReactNode;
}

export function EmptyState({ actions, children, className = '', title }: EmptyStateProps) {
  return (
    <div className={clsx('rounded-lg border border-dashed border-border-default p-8 text-center', className)}>
      <h3 className="text-sm font-semibold text-content-primary">{title}</h3>
      {children ? <div className="mx-auto mt-2 max-w-xl text-sm text-content-secondary">{children}</div> : null}
      {actions ? <div className="mt-4 flex flex-wrap items-center justify-center gap-2">{actions}</div> : null}
    </div>
  );
}

